'use strict';

/**
 * Observes the Child Node Mutations for Einstein Product Recommendations Slot
 * @returns {Object} observer - observer
 */
function recommSlotMutationObserver() {
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

    // Select the Einstein Product Recommendations wrapper node that will be observed for mutations
    var targetNodes = document.querySelectorAll('[id^="cq_recomm_slot-"]');

    // Options for the observer (which mutations to observe)
    var config = { childList: true };

    // Callback function to execute when mutations are observed
    var callback = function (mutationsList) {
        for (var i = 0; i < mutationsList.length; i++) {
            var mutation = mutationsList[i];
            if (mutation.type == 'childList') {
                $('body').trigger('init:productCarousel');
                $('body').trigger('init:bestSellerProductCarousel');
                if (window.lazyLoadInstance) {
                    window.lazyLoadInstance.update();
                }
            }
        }
    };

    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);

    if (targetNodes.length) {
        for (var j = 0; j < targetNodes.length; j++) {
            var targetNode = targetNodes[j];
            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }
    }

    // return the mutation observer object to later disconnect it after window is loaded
    return observer;
}

module.exports = {
    mutationObservers: function () {
        var reccomSlotIDs = $('[id^="cq_recomm_slot-"]');

        if (reccomSlotIDs.length) {
            var observerObject = recommSlotMutationObserver();
            var observerObjectTimer = setInterval(function () {
                if (reccomSlotIDs.children().is(':visible')) {
                    // Stop observing once the slot content has been loaded
                    observerObject.disconnect();
                    clearInterval(observerObjectTimer);
                }
            }, 2000);
        }
    }
};
